import {
  DEFAULT_GAME_PARAM_OPTIONS,
  GAME_PARAM_HERO_CONFIG_TYPE, GAME_PARAM_NORMAL_CONFIG_TYPE,
  GameParamConfigType,
  GameParamKey,
  GameParamKeyIndexMap,
  GameParamMode,
  newDefaultGameParamCreepFaction, newDefaultGameParamCreepGlobal,
  newDefaultGameParamCrystalFaction, newDefaultGameParamCrystalGlobal,
  newDefaultGameParamHeroFaction,
  newDefaultGameParamHeroGlobal,
  newDefaultGameParamHeroPlayer,
  newDefaultGameParamMonsterFaction, newDefaultGameParamMonsterGlobal,
  newDefaultGameParamTowerFaction, newDefaultGameParamTowerGlobal,
  newDefaultGameParamWinCondition,
} from '../create/game-param';

function setParamValue(customGameParam, item, itemIndex) {
  for (const param of item) {
    switch (param.key) {
      // 分路是多选，特殊处理
      case GameParamKey.creep.creepPath: {
        const paramIndex = GameParamKeyIndexMap[param.key][itemIndex];
        const found = customGameParam?.find(item => item.split(':')[0] === `${paramIndex}`);
        if (found) {
          // 按位与操作
          param.value.paths = param.options.filter(item => item.value & +found.split(':')[1]);
          param.value.label = param.value.paths.length <= 0
            ? '无'
            : param.value.paths.map(item => item.label).join('、');
        }
        break;
      }
      case GameParamKey.tower.towerAttack:
      case GameParamKey.tower.towerHealth:
      case GameParamKey.tower.towerAttackRange: {
        const paramIndex = GameParamKeyIndexMap[param.key][itemIndex][0];
        const found = customGameParam?.find(item => item.split(':')[0] === `${paramIndex}`);
        if (found) {
          param.value = param.options.find(item => item.value === +found.split(':')[1]);
        }
        break;
      }
      default: {
        const paramIndex = GameParamKeyIndexMap[param.key][itemIndex];
        const found = customGameParam?.find(item => item.split(':')[0] === `${paramIndex}`);
        if (found) {
          param.value = param.options.find(item => item.value === +found.split(':')[1]);
        }
        break;
      }
    }
  }
}

function setTowerParamValue(customGameParam, item, itemIndex) {
  for (const param of item) {
    const paramIndex = GameParamKeyIndexMap[param.key][itemIndex][0];
    const found = customGameParam?.find(item => item.split(':')[0] === `${paramIndex}`);
    if (found) {
      param.value = param.options.find(item => item.value === +found.split(':')[1]);
    }
  }
}

function parseCustomWinCondition(customGameParam) {
  const param = newDefaultGameParamWinCondition();
  // 先判断19
  const param19 = customGameParam?.find(item => item.split(':')[0] === '19');
  const value19 = +(param19?.split(':')[1] || 0);
  let value = 0;
  if (value19 === 1) {
    // 摧毁防御塔
    const param103 = customGameParam?.find(item => item.split(':')[0] === '103');
    value = +(param103?.split(':')[1] || 0) + 1;
  } else if (value19 === 2) {
    const param105 = customGameParam?.find(item => item.split(':')[0] === '105');
    const value105 = +(param105?.split(':')[1] || 0);
    if (value105 === 0) {
      // 击杀人数
      const param20 = customGameParam?.find(item => item.split(':')[0] === '20');
      value = +(param20?.split(':')[1] || 0) + 4;
    } else if (value105 === 1) {
      // 助攻
      const param104 = customGameParam?.find(item => item.split(':')[0] === '104');
      value = +(param104?.split(':')[1] || 0) + 11;
    }
  }
  if (value) {
    param.value = param.options.find(item => item.value === value);
  }
  return param;
}

function setHeroParamValue(customGameParam, item, childIndex, itemIndex) {
  for (const param of item) {
    switch (param.key) {
      default: {
        const paramIndex = GameParamKeyIndexMap[param.key][childIndex][itemIndex];
        const found = customGameParam?.find(item => item.split(':')[0] === `${paramIndex}`);
        if (found) {
          param.value = param.options.find(item => item.value === +found.split(':')[1]);
        }
        break;
      }
    }
  }
}

interface GameParam {
  title: string,
  key: string,
  configType?: any,
  children: any,
}

function parseHeroGameParam(configType, customGameParam) {
  const result: GameParam = {
    title: '英雄',
    key: 'heroAttribute',
    configType: GAME_PARAM_HERO_CONFIG_TYPE.global,
    children: {},
  };
  switch (configType) {
    case GameParamConfigType.GameParamConfigTypeGlobal: {
      result.children = newDefaultGameParamHeroGlobal();
      const item = result.children[0].formItemArray[0];
      setHeroParamValue(customGameParam, item, 0, 0);
      break;
    }
    case GameParamConfigType.GameParamConfigTypeFaction: {
      result.children = newDefaultGameParamHeroFaction();
      for (const [childIndex, child] of result.children.entries()) {
        const item = child.formItemArray[0];
        setHeroParamValue(customGameParam, item, childIndex, 0);
      }
      break;
    }
    case GameParamConfigType.GameParamConfigTypePlayer: {
      result.children = newDefaultGameParamHeroPlayer();
      for (const [childIndex, child] of result.children.entries()) {
        const players = child.formItemArray;
        for (const [itemIndex, item] of players.entries()) {
          setHeroParamValue(customGameParam, item, childIndex, itemIndex);
        }
      }
      break;
    }
  }
  result.configType = Object.values(GAME_PARAM_HERO_CONFIG_TYPE).find(item => item.value === configType)
    || GAME_PARAM_HERO_CONFIG_TYPE.global;
  return result;
}

function parseNormalGameParam(
  configType,
  customGameParam,
  title,
  key,
  globalChildrenFunction,
  factionChildrenFunction,
) {
  const result: GameParam = {
    title,
    key,
    configType: GAME_PARAM_NORMAL_CONFIG_TYPE.global,
    children: {},
  };
  switch (configType) {
    case GameParamConfigType.GameParamConfigTypeGlobal: {
      result.children = globalChildrenFunction?.();
      const item = result.children[0].formItemArray[0];
      setParamValue(customGameParam, item, 0);
      break;
    }
    case GameParamConfigType.GameParamConfigTypeFaction: {
      result.children = factionChildrenFunction?.();
      for (const [childIndex, child] of result.children.entries()) {
        if (key === 'towerAttribute') {
          // 防御塔有两个占位，需要特殊处理
          const item = child.formItemArray;
          for (const [, subItem] of item.entries()) {
            setTowerParamValue(customGameParam, subItem, childIndex);
          }
        } else {
          const item = child.formItemArray[0];
          setParamValue(customGameParam, item, childIndex);
        }
      }
      break;
    }
  }
  result.configType = Object.values(GAME_PARAM_NORMAL_CONFIG_TYPE).find(item => item.value === configType)
    || GAME_PARAM_NORMAL_CONFIG_TYPE.global;
  return result;
}

function parseCustomGameParam(configType, customGameParam): any[] {
  const result: any[] = [];
  result.push(parseHeroGameParam(getConfigType(configType, 0), customGameParam));
  result.push(parseNormalGameParam(
    getConfigType(configType, 1),
    customGameParam,
    '兵线',
    'creepAttribute',
    newDefaultGameParamCreepGlobal,
    newDefaultGameParamCreepFaction,
  ));
  result.push(parseNormalGameParam(
    getConfigType(configType, 2),
    customGameParam,
    '野怪',
    'monsterAttribute',
    newDefaultGameParamMonsterGlobal,
    newDefaultGameParamMonsterFaction,
  ));
  result.push(parseNormalGameParam(
    getConfigType(configType, 3),
    customGameParam,
    '防御塔',
    'towerAttribute',
    newDefaultGameParamTowerGlobal,
    newDefaultGameParamTowerFaction,
  ));
  result.push(parseNormalGameParam(
    getConfigType(configType, 4),
    customGameParam,
    '水晶',
    'crystalAttribute',
    newDefaultGameParamCrystalGlobal,
    newDefaultGameParamCrystalFaction,
  ));
  return result;
}

function getConfigType(type, index) {
  if (type < 10) {
    // 旧数据，默认"全局统一"配置
    type = 11110 + type;
  }
  const temp = type / (10 ** index);
  return Math.floor(temp % 10);
}

const parseGameParam = function (gameParamMode, configType, customGameParam) {
  interface Result {
    param: any[],
    value: number,
    label: string,
    winCondition: any,
  }
  const isCustom = customGameParam === GameParamMode.GameParamModeCustom;
  const custom = {
    value: GameParamMode.GameParamModeCustom,
    label: '自定义',
    desc: isCustom ? '已自定义参数，' : '自定义游戏对局参数，打造独特对局玩法',
    modifyCustomize: isCustom,
  };
  const result: Result = {
    param: [],
    winCondition: {},
    value: gameParamMode,
    label: DEFAULT_GAME_PARAM_OPTIONS.concat(custom)
      .find(item => item.value === gameParamMode)?.label || '',
  };
  switch (gameParamMode) {
    case GameParamMode.GameParamModeCustom:
      result.param = parseCustomGameParam(configType, customGameParam);
      result.winCondition = parseCustomWinCondition(customGameParam);
      break;
    case GameParamMode.GameParamModeRandom:
      result.param = parseCustomGameParam(configType, customGameParam);
      result.winCondition = parseCustomWinCondition(customGameParam);
      break;
    default:
      break;
  }
  return result;
};

export {
  parseGameParam,
};
